import { Flex, Space, Typography } from 'antd';
import type React from 'react';
import styled from 'styled-components';

const { Text } = Typography;

/**
 * Titolo della sezione di firma con icona.
 */
const SignerTitle = styled(Flex)`
  margin-top: -4px;
  margin-bottom: 16px;
`;
/**
 * Testo con icona per l'header delle sezioni di firma.
 */
const SignerActionText = styled(Text)`
  display: block;
  font-size: 18px;
  line-height: 1.4;
`;
/**
 * Icona colorata per l'header delle sezioni di firma.
 */
const SignerActionIcon = styled.span`
  font-size: 24px;
  color: ${props => props.theme.moduleDelegateColor};
`;

export interface ISignerHeaderProps {
  /** Icona Ant Design (es. <SignatureFilled />) */
  icon: React.ReactNode;
  /** Titolo della sezione */
  title: string;
  /** Descrizione sotto il titolo */
  description?: React.ReactNode;
  /** Contenuto extra a destra (es. stepper) */
  extra?: React.ReactNode;
}

/**
 * Header riutilizzabile per le sezioni di firma.
 * Mostra icona + titolo strong + descrizione opzionale + extra a destra.
 */
export function SignerHeader({
  icon,
  title,
  description,
  extra,
}: ISignerHeaderProps) {
  return (
    <SignerTitle vertical gap={6}>
      <Flex justify="space-between" align="center">
        <SignerActionText strong>
          <Space>
            <SignerActionIcon>{icon}</SignerActionIcon>
            <span>{title}</span>
          </Space>
        </SignerActionText>
        {extra}
      </Flex>

      {description && <Text>{description}</Text>}
    </SignerTitle>
  );
}
